<template>
    <div class="pcBottom">
        <div class="grid grid-cols-3 gap-2 mx-2">
            <div class="h-9">
                <router-link to="/computer">
                    <svg class="w-[20px] h-[20px] mx-auto mt-[10px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#FFFFFF" d="M280.4 148.3L96 300.1V464a16 16 0 0 0 16 16l112.1-.3a16 16 0 0 0 15.9-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.6a16 16 0 0 0 16 16.1L464 480a16 16 0 0 0 16-16V300L295.7 148.3a12.2 12.2 0 0 0 -15.3 0zM571.6 251.5L488 182.6V44.1a12 12 0 0 0 -12-12h-56a12 12 0 0 0 -12 12v72.6L318.5 43a48 48 0 0 0 -61 0L4.3 251.5a12 12 0 0 0 -1.6 16.9l25.5 31A12 12 0 0 0 45.2 301l235.2-193.7a12.2 12.2 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0 -1.7-16.9z"/></svg>
                    <div  class="title">{{ $t('footer.homePage') }}</div>
                </router-link>
                
            </div>
            <div class="h-9">
                <!-- 支付 -->
                <!-- <svg class="w-[20px] h-[20px] mx-auto mt-[10px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                    <path fill="#242c2f" d="M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3 .4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5 .9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5 .9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8 .1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7 .9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4 .2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9 .9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3 .1 4.6 1.6 6.7 6.2 7.5 4.7 .8 9.4 1.6 14.2 1.7 14.3 .3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5 .6-1.5 1.1-3 1.3-4.6 .4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5 .4-.3 .8-.6 1.4-1 .5 3.2 .9 6.2 1.5 9.2 .5 2.6 2.1 4.3 4.5 4.4 4.6 .1 9.1 .1 13.7 0 2.3-.1 3.8-1.6 4-3.9 .1-.8 .1-1.6 .1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8 .1-1.6 .3-2.5 .3-8.2 .4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5 .1 2.8-.1 5.6 0 8.3 .1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4 .8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7 .3 6.9 .2 13.9 .3 20.8 0 .4-.1 .7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9 .1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7 .1 2.5 .2 2.5 1.7 4.1 4.1 4.2 5.9 .1 11.8 .1 17.7 0 2.5 0 4-1.7 4.1-4.1 .1-.8 .1-1.7 .1-2.5v-60.7c.9 .7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2 .2-2.4 .3-3.6 .5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6 .7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4 .7 0 1.4 .2 2.1 .3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2 .8-2.4 1.8-3.1 3-.6 .9-.7 2.3-.5 3.4 .3 1.3 1.7 1.6 3 1.5 .6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1 .3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7 .3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3 .8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6 .7-3 1.2-6.1 1.7-9.1 .2-4.7 .2-9.6 .2-14.5z"/>
                </svg>
                <div  class="title">{{ $t('link.pay') }}</div> -->

                <!-- 打赏 -->
                <!-- 打赏需要在已经登录的前提下， 如果没有-->

                <!-- <router-link to="/computer/login" v-show="!isLogin">
                    <svg class="w-[20px] h-[20px] mx-auto mt-[10px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
                        <path fill="#FFFFFF" d="M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"/>
                    </svg>
                    <div class="title">{{ $t('link.tip') }}</div>
                </router-link> -->

                <!-- 如果用户没有平台槟榔 需要先去购买 -->
                <!-- 这里先要知道用户当前有多少个槟榔 -->
                <!-- 先查看用户余额足不足 余额不足则问用户是否去充值 余额足则直接打赏 最好是打赏成功跳一下 重新打开播放 -->

                <!-- <svg  @click="tips" class="w-[20px] h-[20px] mx-auto mt-[10px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
                    <path fill="#FFFFFF" d="M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"/>
                </svg>
                <div  @click="tips" class="title">{{ $t('link.tip') }}</div> -->
            </div>
            <div class="h-9">

                <!-- 分享 -->
                <!-- 无论登录与否，都可以分享，登录后分享，可能会有意外的收获。 -->
                <router-link :to="{ name: 'computerShareGuys', params: { id: video }}">
                    <!-- <router-link :to="`/computer/share/`+video"> -->
                    <svg class="w-[20px] h-[20px] mx-auto mt-[10px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path fill="#FFFFFF" d="M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM304 296c-14.6 0-27.8 5.6-37.8 14.7l-68-40.8a56.3 56.3 0 0 0 0-27.8l68-40.8C276.2 210.4 289.4 216 304 216c30.9 0 56-25.1 56-56s-25.1-56-56-56-56 25.1-56 56c0 4.8 .6 9.5 1.7 13.9l-68 40.8C171.8 205.6 158.6 200 144 200c-30.9 0-56 25.1-56 56s25.1 56 56 56c14.6 0 27.8-5.6 37.8-14.7l68 40.8a56.1 56.1 0 0 0 -1.7 13.9c0 30.9 25.1 56 56 56s56-25.1 56-56C360 321.1 334.9 296 304 296z"/>
                    </svg>
                    <div class="title">{{ $t('link.share') }}</div>
                </router-link>


            </div>
        </div>

        <!-- 自定义颜色的遮罩层 :shade="[0.5, '#fadfd9']" -->
        <!-- 点击遮罩层则关闭弹出层 :shadeClose="true" -->
        <!-- 不显示关闭按钮 :closeBtn="0" -->
        <!-- 垂直居中 offset="auto"  -->
        <s3-layer class="notConfirmed" v-model="layerTips" :shade="[0.5, '#fadfd9']" :shadeClose="true" :closeBtn="0" :anim="3" offset="auto" :title="title" area="325px">
            <div class="textCenter">帐户余额不够打赏，先去充值吧。</div>
            <div class="w-[285px] p-[20px]">
                <button @click="goPay" class="block w-full px-5 butGo py-[15px] border text-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1 focus:outline-none">
                    {{ $t('text.goRecharge') }}
                </button>
            </div>
        </s3-layer>

    </div>
</template>

<script>
// 引入公共函数
import tool from '@/assets/js/tool'
// 使用全局变量
import { useGlobalStore } from '@/assets/js/globalStore'
import global from '@/assets/js/global' // 全局变量
// 需要监听全局变量 global.isLogin 的变化
import { ref, watch, onMounted } from 'vue'
export default {
    // 接收父组件传进来的参数
    props: { 
        // 本内容的金额
        amount: Intl,
        // balance: Intl,
        // 分享出去的视频是哪一个，由父组件传入。
        // <ZonePay :amount="this.$route.query.amount" :video="video_id" /> 
        video: Intl, 
    },
    data() {
        return {
            layerTips: false, // 控制右侧菜单的显示与隐藏
        }
    },
    // 本组件接收的参数传入 setup
    setup() {

        const globalStore = useGlobalStore()
        const login = ref(tool().resolveLoginState())

        const refreshLoginState = () => {
            const normalized = tool().resolveLoginState(globalStore.login)
            login.value = normalized
            global.isLogin = normalized
            localStorage.setItem('isLogin', String(normalized))
            if (globalStore.login !== normalized) {
                globalStore.setLogin(normalized)
            }
        }

        onMounted(refreshLoginState)

        watch(() => globalStore.login, refreshLoginState)

        return {
            login
        }
    },
    methods: {
        tips () {
            // 判断当前帐户余额够不够打赏 
            // 如果余额不够打赏 要提示用户是不是去充值
            // if ( parseInt(this.balance) < parseInt(this.props.amount) ) this.layerTips = true
            // console.log( this.balance )
            // console.log( this.props.amount )
        },
        goPay() {
            // 关闭弹窗，不然跳到下一个页面，这个弹窗还在。
            this.layerTips = false
            this.$router.push({ path: '/computer/receiving/payments', query: {  }})
        }
    } // End methods(...)
}
</script>

<style lang="scss" scoped>

</style>